export const progress_history_zh_CN = {
    progress_history_name: '名字',
}